import React from "react";
import { Popover } from "react-tiny-popover";
import cn from "classnames";

import DropdownIcon from "assets/icons/dropdown-icon.svg?react";

import { MonthPicker } from "shared/ui/components/MonthPicker";

import styles from "./MonthPickerInput.module.scss";
import { Typography } from "../Typography";

interface CustomComponentProps {
  children: React.ReactNode;
  className?: string;
}

const CustomComponent = React.forwardRef<HTMLLabelElement, CustomComponentProps & { component?: React.ElementType }>(
  (props, ref) => {
    const Component = props.component || "label";

    return (
      <Component ref={ref} className={props.className}>
        {props.children}
      </Component>
    );
  }
);

const DatePickerInput = ({
  popoverOpen,
  value,
  formattedInputValue,
  onMonthSelect,
  onCalendarClick,
  disabled,
  component,
  ...restProps
}) => (
  <div className={styles.root}>
    <Popover
      isOpen={popoverOpen}
      onClickOutside={() => onCalendarClick()}
      containerStyle={{ zIndex: "900" }}
      transform={{ top: 16, left: 10 }}
      transformMode="relative"
      positions={["bottom"]}
      align="end"
      content={
        <MonthPicker
          className={styles.monthPicker}
          date={value}
          onChange={onMonthSelect}
        />
      }
    >
      <CustomComponent className={styles.button} component={component}>
        <Typography variant="bodyS" className={styles.dateText}>
          {formattedInputValue}
        </Typography>
        <DropdownIcon
          className={cn(styles.icon, { [styles.iconActive]: popoverOpen })}
          name="calendar"
        />
        <input
          {...restProps}
          type="text"
          disabled={disabled}
          readOnly
          value={formattedInputValue}
          className={styles.input}
          onClick={onCalendarClick}
        />
      </CustomComponent>
    </Popover>
  </div>
);

export default DatePickerInput;
